import { getProductType, ProductEnum } from "../../constants/login";

export const DEFAULT_IMPORT_MODULE_NAME = "Settings";
export const SPA_TRANSACTIONS_MODULE_NAME = "Transactions";
export const GOLF_MODULE_NAME = "Golf";

/** Spa excel file names that use ImportExcelData moduleName "Transactions". */
export const SPA_TRANSACTIONS_EXCEL_FILE_NAMES = new Set([
  "Therapist",
  "ServiceDetail",
  "PackageDetail",
]);

/** Golf link/mapping sheets resolve player types via Golf module GraphQL. */
export const GOLF_MODULE_EXCEL_FILE_NAMES = new Set([
  "PlayerTypeMapping",
  "RateTypeMapping",
]);

/** Removes generated timestamp suffix from exported .xlsx names. */
export const stripGeneratedExcelTimestamp = (fileName: string): string =>
  fileName.replace(/\.xlsx$/i, "").replace(/_\d{2}-\d{2}-\d{4}_\d{6}$/i, "");

export const resolveImportModuleName = (
  productId: number,
  excelFileName: string,
): string => {
  const product = getProductType(productId) as ProductEnum | undefined;
  const baseName = stripGeneratedExcelTimestamp(excelFileName);

  if (product === ProductEnum.SPA) {
    return SPA_TRANSACTIONS_EXCEL_FILE_NAMES.has(baseName)
      ? SPA_TRANSACTIONS_MODULE_NAME
      : DEFAULT_IMPORT_MODULE_NAME;
  }

  if (product === ProductEnum.GOLF) {
    return GOLF_MODULE_EXCEL_FILE_NAMES.has(baseName)
      ? GOLF_MODULE_NAME
      : DEFAULT_IMPORT_MODULE_NAME;
  }

  return DEFAULT_IMPORT_MODULE_NAME;
};

/** Visual One expects plain `{FileName}.xlsx` for module-specific imports. */
export const resolveImportApiFileName = (
  excelFileName: string,
  moduleName: string,
): string => {
  const withExt = excelFileName.toLowerCase().endsWith(".xlsx")
    ? excelFileName
    : `${excelFileName}.xlsx`;

  if (
    moduleName === SPA_TRANSACTIONS_MODULE_NAME ||
    moduleName === GOLF_MODULE_NAME
  ) {
    return `${stripGeneratedExcelTimestamp(withExt)}.xlsx`;
  }

  return withExt;
};

export type ImportDataUtilityRow = {
  importData: string;
  totalRows: number;
  excelSheetName: string;
};

/** Transactions payload uses totalRows 0 on each dataUtilityImportData item. */
export const normalizeImportDataUtilityItems = <T extends ImportDataUtilityRow>(
  items: T[],
  moduleName: string,
): T[] => {
  if (moduleName !== SPA_TRANSACTIONS_MODULE_NAME) {
    return items;
  }

  return items.map((item) => ({ ...item, totalRows: 0 }));
};
